// import { Map, Marker } from "pigeon-maps";

import { CopyFilled, CopyOutlined } from "@ant-design/icons";
import { useState } from "react";

type TProps = {
  geoLocation?: {
    latitude: number;
    longitude: number;
  };
};

export function LiveLocation(props: TProps) {
  // const [hue, setHue] = useState(0);
  // const color = "#0bb68c";
  const [isTextCopied, setTextCopied] = useState<boolean>(false);

  return (
    <>
      <iframe
        src={`https://maps.google.com/maps?q=${props?.geoLocation?.latitude},${props?.geoLocation?.longitude}&output=embed`}
        height="600"
        width="100%"
        title="Engineer Location"
      ></iframe>
      <span>
        Cordinates : {props?.geoLocation?.latitude},{" "}
        {props?.geoLocation?.longitude}
        {isTextCopied ? (
          <CopyFilled
            style={{ marginLeft: "5px", fontSize: "1rem" }}
            onClick={async () => {
              await navigator.clipboard
                .writeText(`${props?.geoLocation?.latitude},
        ${props?.geoLocation?.longitude}`);
              setTextCopied(true);
            }}
          />
        ) : (
          <CopyOutlined
            style={{ cursor: "pointer", marginLeft: "5px", fontSize: "1rem" }}
            onClick={async () => {
              await navigator.clipboard
                .writeText(`${props?.geoLocation?.latitude},
        ${props?.geoLocation?.longitude}`);
              setTextCopied(true);
            }}
          ></CopyOutlined>
        )}
      </span>
    </>
    // <Map
    //   height={500}
    //   defaultCenter={[
    //     props?.geoLocation?.latitude as number,
    //     props?.geoLocation?.longitude as number,
    //   ]}
    //   defaultZoom={13}
    // >
    //   <Marker
    //     width={50}
    //     anchor={[
    //       props?.geoLocation?.latitude as number,
    //       props?.geoLocation?.longitude as number,
    //     ]}
    //     color={color}
    //     onClick={() => setHue(hue + 20)}
    //   />
    // </Map>
  );
}
